import RequestAbstract from "../abstract";

export default class PayinInstances extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payin-instances";
    }

    /**
     * Manually confirm a stuck payin — the operator asserting what happened.
     *
     * `text` is the bank reference and is required: the decision leaves no gateway
     * trace, so it is the only account of it. `amount` is what arrived, in minor
     * units, and is required too: the payin is credited with it, not with the
     * requested amount.
     */
    async confirm(id, text, amount) {
        return await this.post(`${this.link}/${id}/confirm`, { text, amount });
    }

    /** Manually reject a stuck payin. `text` is the reason, and is required. */
    async reject(id, text) {
        return await this.post(`${this.link}/${id}/reject`, { text });
    }
}
